// | ------------------------------------------------------------------------
// | Modals
// | ------------------------------------------------------------------------

import { Modal } from "bootstrap";

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars";
import { smoother } from '../gsap/index'

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    const header = document.querySelector(".site-header");
    const smoothContent = document.getElementById("smooth-content");
    var modals = document.querySelectorAll(".modal");

    modals.forEach(function (modal) {

        modal.addEventListener("show.bs.modal", (event) => {

            // Remove modal padding as not required with no scroll bar
            modal.style.paddingRight = "0px";

            // Add header and content padding to prevent stuff jumping around
            header.style.paddingRight = scrollbarWidth + "px";
            smoothContent.style.paddingRight = scrollbarWidth + "px";

            // Remove any scroll from the HMTL tag
            document.documentElement.style.overflow = "hidden";

            // Stop smooth scroll
            smoother.paused(true);

            // Apply background blur when modal opens
            const overlay = document.querySelector(".overlay");
            overlay.style.zIndex = "1997";
            overlay.classList.add("show");

            // Check if the modal has '.modal-body' and if so add scrollbars when required
            var modalBody = modal.querySelector(".modal-body");

            if (modalBody) {

                // Add nice scrollbars to menu when needed
                var modalScroll = OverlayScrollbars(modalBody, {
                    overflow: {
                        x: "hidden",
                    },
                    scrollbars: {
                        visibility: "auto",
                        autoHide: "leave",
                    },
                });

                // Add scroll shadows when needed
                var modalScrollElement = modal.querySelector(".modal-body");

                const { viewport } = modalScroll.elements();
                const { scrollLeft, scrollTop } = viewport;

                // Check if bottom shadow required when menu opens
                if ((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight) {
                    modalScrollElement.classList.add('scroll-bottom');
                } else {
                    modalScrollElement.classList.remove('scroll-bottom');
                }

                // Add remove shadows as required on scroll
                viewport.onscroll = (event) => {
                    if (viewport.scrollTop > 0) {
                        modalScrollElement.classList.remove('scroll-top');
                    } else {
                        modalScrollElement.classList.add('scroll-top');
                    }

                    if ((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight) {
                        modalScrollElement.classList.add('scroll-bottom');
                    } else {
                        modalScrollElement.classList.remove('scroll-bottom');
                    }
                }

            }

        });


        modal.addEventListener("hide.bs.modal", (event) => {

            // Start Smooth Scroll
            smoother.paused(false);

            // Allow HTML to scroll again
            document.documentElement.style.overflow = "auto";

            // Remove padding from content
            smoothContent.style.paddingRight = "0px";

            // Remove padding from header
            header.style.paddingRight = "0px";

            // Remove background blur when modal closes
            const overlay = document.querySelector(".overlay");
            overlay.style.zIndex = "";
            overlay.classList.remove("show");

        });


    })

    function initModalTrigger() {
        if (window.location.href.indexOf('#bookMeetingModal') !== -1) {
            
            const modalEl = document.getElementById('bookMeetingModal');

            if (modalEl) {
                const bookModal = new Modal(modalEl); // use bootstrap.Modal
                bookModal.show();

                // Disable focus trap
                modalEl.addEventListener('shown.bs.modal', function () {

                    document.removeEventListener('focusin', Modal._enforceFocus);

                    // Remove modal padding as not required with no scroll bar
                    modalEl.style.paddingRight = "0px";

                    // Add header and content padding to prevent stuff jumping around
                    header.style.paddingRight = scrollbarWidth + "px";
                    smoothContent.style.paddingRight = scrollbarWidth + "px";

                    // Remove any scroll from the HMTL tag
                    document.documentElement.style.overflow = "hidden";

                    // Stop smooth scroll
                    smoother.paused(true);

                    // Apply background blur when modal opens
                    const overlay = document.querySelector(".overlay");
                    overlay.style.zIndex = "1997";
                    overlay.classList.add("show");

                    // Check if the modal has '.modal-body' and if so add scrollbars when required
                    var modalBody = modalEl.querySelector(".modal-body");

                    if (modalBody) {

                        // Add nice scrollbars to menu when needed
                        var modalScroll = OverlayScrollbars(modalBody, {
                            overflow: {
                                x: "hidden",
                            },
                            scrollbars: {
                                visibility: "auto",
                                autoHide: "leave",
                            },
                        });

                        // Add scroll shadows when needed
                        var modalScrollElement = modal.querySelector(".modal-body");

                        const { viewport } = modalScroll.elements();
                        const { scrollLeft, scrollTop } = viewport;

                        // Check if bottom shadow required when menu opens
                        if ((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight) {
                            modalScrollElement.classList.add('scroll-bottom');
                        } else {
                            modalScrollElement.classList.remove('scroll-bottom');
                        }

                        // Add remove shadows as required on scroll
                        viewport.onscroll = (event) => {
                            if (viewport.scrollTop > 0) {
                                modalScrollElement.classList.remove('scroll-top');
                            } else {
                                modalScrollElement.classList.add('scroll-top');
                            }

                            if ((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight) {
                                modalScrollElement.classList.add('scroll-bottom');
                            } else {
                                modalScrollElement.classList.remove('scroll-bottom');
                            }
                        }

                    }       
                });
            }
            
        }
    }

    // Check if DOM is already ready
    if (document.readyState !== 'loading') {
        initModalTrigger();
    } else {
        document.addEventListener('DOMContentLoaded', initModalTrigger);
    }     

    // Virtual Office Modal

    var officeModal = document.querySelector("#officeModal");

    if (officeModal) {

        // Load Metaverse code when modal is opened
        officeModal.addEventListener("show.bs.modal", (event) => {

            var iframeHolder = officeModal.querySelector(".office-iframe");

            // Check if iframe already exists
            const existingIframe = iframeHolder.querySelector("iframe");
            console.log("Existing modal?", existingIframe);

            if (!existingIframe) {
                const iframe = document.createElement("iframe");
                iframe.src = "https://www.spatial.io/embed/Parametrixs-Metaverse-67e19efc2d349d3ca73441a0?share=1073890896519751663&autoplay=1&enableRtc=1"
                iframe.width = "1280px"
                iframe.height = "720px"
                iframe.allow = "camera; fullscreen; autoplay; display-capture; microphone; clipboard-write"

                iframeHolder.appendChild(iframe)

                //Send an email notification
                fetch("/ajax/office-modal-notification", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                        "Custom-Security-Header": "W0A84pVTAcnfLDHGafbenp0vwv8OVKPm"
                    },
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("Network response was not ok")
                        }
                        return response.json()
                    })
                    .then(json => {
                        if (!json.success) {
                            console.error("Server returned error:", json);
                            alert(json.msg || "An unknown error occurred");
                        } else {
                            console.log("Success:", json);
                        }
                    })
                    .catch(error => {
                        console.error("Fetch error:", error);
                        alert("Failed to communicate with server. Check console for details.");
                    });


                // iframe.onload = () => {
                //     console.log("Iframe loaded, waiting for connection...");
                //     // Optional: Send a postMessage to request connection status
                //     iframe.contentWindow.postMessage({ action: "getConnectionStatus" }, "https://www.spatial.io");
                // };
            }

        });

    }


});


